import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import classes from './Row.module.scss';

const Row = ({ children, className, withBorder = true, ...other }) => {
  const cnwb = cn(
    className,
    { [classes.withBorder]: withBorder },
    classes.first
  );

  return (
    <tr className={cnwb} {...other}>
      {children}
    </tr>
  );
};

Row.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  withBorder: PropTypes.bool,
  className: PropTypes.string
};

export default Row;
